import styled from 'styled-components';
import { COLORS, MAX_SCREEN } from '@themes';

export const Style = styled.div<{ $top: string }>`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 11vw;
  min-height: 145px;
  .flex {
    display: flex;
  }

  .container-label-currency {
    display: flex;
    align-items: flex-end;
    margin-bottom: 5px;
  }

  .column-1 {
    text-align: center;
    height: 100%;
    width: 40%;
    min-width: 260px;
    position: relative;
    z-index: 1;
    display: flex;
    text-align: left;
    .box {
      position: absolute;
      right: 10%;
      top: 10%;
      width: 90%;
    }
    .leaf {
      width: 15%;
      margin-left: 5%;
      animation: leaf 4s linear infinite;

      @keyframes leaf {
        0% {
          transform: rotate(-20deg);
        }
        50% {
          transform: rotate(40deg);
        }
        100% {
          transform: rotate(-20deg);
        }
      }
    }

    .text {
      margin-top: 4%;
      margin-left: 6%;
      width: 100%;

      .text-Co2 {
        font-size: 0.6vw;
        @media (max-width: ${MAX_SCREEN}px) {
          font-size: 10px;
        }
      }
      .space {
        margin-left: 2%;
      }
    }
  }

  .column-2 {
    height: 100%;
    width: 60%;
    font-weight: bold;
    position: relative;
    min-width: 450px;
    display: flex;
    .coin {
      width: 11%;
      animation: rotate3d 6s linear infinite;
      animation-direction: alternate;

      @keyframes rotate3d {
        0% {
          transform: perspective(1000px) rotateY(360deg);
        }
        90% {
          transform: perspective(1000px) rotateY(360deg);
        }
        100% {
          transform: perspective(1000px) rotateY(0deg);
        }
      }
    }
    .animation {
      position: absolute;
      width: 11%;
      height: 8%;
      top: 65%;
      left: -4%;
      background-color: ${COLORS.WHITE_1};
      transform: rotate(45deg);
      filter: blur(6px);
      animation: shiny 3s linear infinite;
      @keyframes shiny {
        0% {
          top: 65%;
          left: -4%;
          opacity: 0.5;
        }
        50% {
          top: 25%;
          left: 4%;
          opacity: 0.2;
        }
        100% {
          top: 65%;
          left: -4%;
          opacity: 0.5;
        }
      }
    }
    .text {
      width: 100%;
      margin-top: 6%;
      margin-left: 4%;

      @media (max-width: ${MAX_SCREEN}px) {
        margin-top: ${({ $top }) => $top};
      }
    }

    .logo {
      width: 20%;
      position: absolute;
      right: 0;
      bottom: 10%;
    }
  }
`;
